module.exports = __webpack_public_path__ + "img/blood_button1.f53d5278.jpg";